import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule, MatHint } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'add-multiple-imeis',
    imports: [
        TranslocoModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatHint,
        ReactiveFormsModule,
        MatButtonModule,
    ],
    templateUrl: './add-multiple-imeis.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './add-multiple-imeis.component.scss'
})
export class AddMultipleImeisComponent {
    imeis = '';

    constructor(
        // @Inject(MAT_DIALOG_DATA) public data: any,
        public matDialogRef: MatDialogRef<AddMultipleImeisComponent>
    ) {}

    ngOnInit(): void {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Save and close
     */
    close(): void {
        // Save the message as a draft

        // Close the dialog
        this.matDialogRef.close();
    }

    /**
     * Discard the message
     */
    discard(): void {}

    /**
     * Send the message
     */
    save(): void {
        let result = this.imeis.split(/[, \n]+/g);

        this.matDialogRef.close(result);
    }
}
